export default {
    'ES-AN': 'Andalucía',
    'ES-AR': 'Aragón',
    'ES-CN': 'Canarias',
    'ES-CB': 'Cantabria',
    'ES-CM': 'Castilla La Mancha',
    'ES-CL': 'Castilla y León',
    'ES-CT': 'Catalunya (Cataluña)',
    'ES-NC': 'Comunidad Foral de Navarra/Nafarroako Foru Komunitatea',
    'ES-VC': 'Comunidad Valenciana/Comunitat Valenciana',
    'ES-MD': 'Comunidad de Madrid',
    'ES-EX': 'Extremadura',
    'ES-GA': 'Galicia (Galicia)',
    'ES-IB': 'Illes Balears (Islas Baleares)',
    'ES-RI': 'La Rioja',
    'ES-PV': 'País Vasco/Euskadi',
    'ES-AS': 'Principado de Asturias',
    'ES-MC': 'Región de Murcia'
};
